import React, { Suspense, useEffect, useState } from "react";
import { Loader } from "@components/loader/mobile/";
import { useTranslation } from "react-i18next";
import { TNotification } from "./TNotification";
import { NotificationContext } from "./NotificationContext";
import { useRootAppStore } from "@hooks";

function NotificationContainer(props: { children: JSX.Element }) {
	const [notification, setNotification] = useState<TNotification | null>(
		null
	);
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	const parseNotificationMessage = (
		notificationData: TNotification | null
	) => {
		let notificationDataMessage = "";
		if (notificationData == null) {
			return;
		}

		if (typeof notificationData.data === "string") {
			notificationDataMessage = t(notificationData.data);
		} else if (Array.isArray(notificationData.data)) {
			notificationData.data.map((entry) => {
				if (entry.message && typeof entry.message == "string") {
					notificationDataMessage =
						notificationDataMessage +
						" " +
						t(entry.message, entry?.options || {});
				} else {
					notificationDataMessage = t("COMMON.ERROR_MESSAGES.TITLE");
				}
			});
		} else {
			notificationDataMessage = t("COMMON.ERROR_MESSAGES.TITLE");
		}
		return notificationDataMessage;
	};

	const contextValue = {
		showNotification: (data: TNotification) => {
			setNotification(data);
		},
		notification: notification,
	};

	useEffect(() => {
		const parsedMessage = parseNotificationMessage(notification);
		if (parsedMessage && notification) {
			if (notification.type == "success") {
				rootStore.notificationStore.success(parsedMessage);
			} else if (notification.type == "error") {
				rootStore.notificationStore.error(parsedMessage);
			} else if (notification.type == "warning") {
				rootStore.notificationStore.warning(parsedMessage);
			} else {
				rootStore.notificationStore.info(parsedMessage);
			}
		}
	}, [notification]);

	return (
		<Suspense fallback={<Loader isLoading />}>
			<NotificationContext.Provider value={contextValue}>
				{props.children}
			</NotificationContext.Provider>
		</Suspense>
	);
}

export default NotificationContainer;
